/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { IModelConnection } from "@itwin/core-frontend";
import { SpatialViewState, ViewState } from "@itwin/core-frontend";
import { ViewStateProps } from "@itwin/core-common";
import SavedViewsApi  from "./SavedViewsApi";
import { SavedViewItwin3dViewInterface } from "./SavedViewsInterfaces";

export class ViewSetup {

  public static savedViewObject : SavedViewItwin3dViewInterface | undefined; 
  public static viewStateObject : ViewState;
  /** Queries for and loads the default view for an iModel. */
  public static getDefaultView = async (imodel: IModelConnection): Promise<ViewState> => {
    const iTwinId = imodel.iTwinId ?? "";
    const iModelId = imodel.iModelId ?? "";

    // Store the saved view id in local storage
    let sViewId = localStorage.getItem("saved-view-id-"+iModelId);
    let savedViewResponse;
    if(sViewId) {
      savedViewResponse = await SavedViewsApi.getByIdAsync(sViewId ?? "");
    } else {
      const allSavedViews = await SavedViewsApi.getAllAsync(iTwinId, iModelId);
      const savedViewId = allSavedViews.savedViews.find((saveview) => saveview.displayName === process.env.IMJS_SAVED_VIEW_DISPLAY_NAME ?? "")?.id;  
      savedViewResponse = await SavedViewsApi.getByIdAsync(savedViewId ?? "");
      if(savedViewId !== undefined) {
        localStorage.setItem("saved-view-id-"+iModelId, savedViewId);

      }      
    }
   
    // Get the saved view based on SAVED_VIEW_DISPLAY_NAME
    const savedView = savedViewResponse.savedView.savedViewData?.legacyView;

    // Create the view state using savedView
    const viewState = await ViewSetup.createSpatialViewState(imodel, savedView);

    ViewSetup.savedViewObject = savedView;
    ViewSetup.viewStateObject = viewState;

    return viewState;
  };

  private static createSpatialViewState = async (
    iModelConnection: IModelConnection,
    savedView: any,
    _onSourceNotFound?: () => void
  ): Promise<ViewState > => {
    const props: ViewStateProps = {
      viewDefinitionProps: savedView.viewDefinitionProps,
      categorySelectorProps: savedView.categorySelectorProps,
      modelSelectorProps: savedView.modelSelectorProps,
      displayStyleProps: savedView.displayStyleProps,
    };
    const viewState = SpatialViewState.createFromProps(props, iModelConnection);
    await viewState.load();
    return viewState as ViewState;
  }

}
